import {REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX} from '/enum/records.enum';

export default {
  reportName: REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
};
